import { useQuery } from '@tanstack/react-query';

import { INVITATIONS_SEARCH_LIMIT } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { GetTenantsResponse } from 'src/types/rest/managementPortalApi';

export const useSearchTenantsToInviteTo = (search?: string) => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  const base = new URL(apiHost).origin;

  return useQuery({
    enabled: !!search,
    queryFn: () => {
      /**
       * Build the query string via URLSearchParams so reserved characters in
       * search terms are encoded correctly.
       *
       * The API paginates results with `nextCursor`, but Beyond Autocomplete
       * cannot currently request and append another page while its menu is open.
       * Keep the response bounded until it supports native load-more behavior.
       *
       * TODO: When load-more support is available, replace `useQuery` with
       * React Query's `useInfiniteQuery`, use `getNextPageParam` to retain
       * `nextCursor`, and flatten de-duplicated pages for the autocomplete.
       */
      const url = new URL('/internal/api/v1/invitations/tenants', base);

      url.searchParams.set('limit', INVITATIONS_SEARCH_LIMIT.toString());
      url.searchParams.set('search', search ?? '');

      return apiRequest<GetTenantsResponse>({
        url: url.toString(),
      });
    },
    queryKey: ['searchTenantsToInviteTo', search],
  });
};
